module.exports = __webpack_public_path__ + "img/12.0db3e435.png";